import React, { useState, useRef } from "react";
import { Icon } from "@iconify/react";
import "./Style/calendar.css";

export default function FullCalendar({ isEdit, setEdit }) {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(currentDate);
  const datePickerRef = useRef(null); // Reference to the date input

  function handleEdit() {
    setEdit(!isEdit);
  }

  // Handle navigation
  const prevMonth = () => {
    const prevDate = new Date(currentDate);
    prevDate.setMonth(currentDate.getMonth() - 1);
    setCurrentDate(prevDate);
  };

  const nextMonth = () => {
    const nextDate = new Date(currentDate);
    nextDate.setMonth(currentDate.getMonth() + 1);
    setCurrentDate(nextDate);
  };

  //   const handleDateClick = () => {
  //     datePickerRef.current.click();
  //   };

  const handleDateChange = (e) => {
    const newDate = new Date(e.target.value);
    setSelectedDate(newDate);
    setCurrentDate(newDate);
  };

  const month = currentDate.toLocaleString("default", { month: "short" });
  const year = currentDate.getFullYear();
  const firstDay = new Date(year, currentDate.getMonth(), 1).getDay();
  const totalDays = new Date(year, currentDate.getMonth() + 1, 0).getDate();

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const today = currentDate.getDate();

  const generateDays = () => {
    let days = [];
    let currentRow = [];

    // Empty cells before the first day of the month
    for (let i = 0; i < firstDay; i++) {
      currentRow.push(<div key={`empty-${i}`} className="empty"></div>);
    }

    // Loop through all the days of the month
    for (let day = 1; day <= totalDays; day++) {
      const isToday =
        day === today &&
        currentDate.getMonth() === new Date().getMonth() &&
        currentDate.getFullYear() === new Date().getFullYear();

      const dayElement = (
        <div key={day} className={`date ${isToday ? "today" : ""}`}>
          {isToday ? <div className="today-circle">{day}</div> : day}
        </div>
      );

      currentRow.push(dayElement);

      if (currentRow.length === 7 || day === totalDays) {
        days.push(
          <div key={`row-${day}`} className="week">
            {currentRow}
          </div>
        );
        currentRow = [];
      }
    }

    return days;
  };

  return (
    <div className="calendar">
      <div className="calendar-header">
        <span className="option">Progress</span>
        <div className="month-year-nav">
          <span onClick={prevMonth}>
            <Icon icon="fluent:triangle-left-16-filled" className="edit" />
          </span>
          <span className="month-year">
            {month} <span className="year">{year}</span>
          </span>
          <span onClick={nextMonth}>
            <Icon icon="fluent:triangle-right-12-filled" className="edit" />
          </span>
        </div>
        <span onClick={handleEdit}>
          <Icon icon="fluent:edit-32-filled" className="edit" />
        </span>
      </div>

      <div className="calendar-body">
        <div className="days">
          {daysOfWeek.map((day) => (
            <div key={day} className="day">
              {day}
            </div>
          ))}
        </div>
        <div className="dates">{generateDays()}</div>
      </div>
    </div>
  );
}
